export const AUTH_PROVIDER_TYPES = ['SSO', 'PASSWORD'];
export const UNKNOWN_AUTH_PROVIDER_TYPE = 'UNKNOWN';
export const AUTH_PROVIDER_TYPES_OR_UNKNOWN = [...AUTH_PROVIDER_TYPES, UNKNOWN_AUTH_PROVIDER_TYPE];
//# sourceMappingURL=auth.model.js.map